export default __webpack_public_path__ + "static/media/dark9.d0399bfe.png";